import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Profile } from 'src/app/server-api/models';
import { DropdownComponent } from 'src/app/utils-flc/dropdown/dropdown.component';
import { EnumDropdownComponent } from 'src/app/utils-flc/enum-dropdown/enum-dropdown.component';

@Component({
  selector: 'app-profile-dropdown',
  templateUrl: './profile-dropdown.component.html',
  styleUrls: ['./profile-dropdown.component.css']
})
export class ProfileDropdownComponent extends EnumDropdownComponent {

  constructor(
    public override translate: TranslateService,
    public override fb: FormBuilder
    ) {
    super(translate, fb);
  }

  override ngOnInit(): void {

    this.placeholderText = 'profile-dropdown.choose';

    super.ngOnInit();
  }

  override getItems(): void {

    super.getItems();
    this.items = [];
    
    this.items = Object.keys(Profile).map(key => Profile[key]);
            
    this.setPreSelect(this.preSelect);
  }
}

